import React from "react"

import ContextSection from "../components/ContextSection"
import WireframingSection from "../components/WireframingSection"
import PrototypingSection from "../components/PrototypingSection"
import Container from "../components/Container"
import Header from "../components/BigHeader"

class SolutionSection extends React.Component {
  render() {
    return (
      <>
        <Container>
          <Header>The Solution</Header>
        </Container>
        <ContextSection />
        <WireframingSection />
        <PrototypingSection />
      </>
    )
  }
}

export default SolutionSection
